<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + ' Cond. Grupos'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarGrupo">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoGrupo()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nuevo Grupo
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
    [columnDefs]="columnDefsGrupo" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
    id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
    [pagination]="true" [rowData]="rowDataGrupo" *ngIf="!verFormularioAgregarGrupo">
  </ag-grid-angular>
  <app-promo-grupo-form
    [grupo]="grupo"
    [idPromo]="idPromo"
    (back)="back()"
    (create)="guardarGrupo($event)"
    *ngIf="verFormularioAgregarGrupo"></app-promo-grupo-form>
</ng-template>
